// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import axios from "./libs/axios";
import APIs from "./apis";
import filters from "./libs/filters";

// 三方框架
import Antd from "ant-design-vue";
import "@/assets/theme/default.less";
import Viser from "viser-vue";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/theme/element-reset.less';
import vCharts from './components/echarts';
// import "@/mock";
// 全局配置
Vue.config.productionTip = false;

// 注入全局变量
Vue.prototype.$axios = axios;
Vue.prototype.$apis = APIs;
Vue.prototype.$eventBus = new Vue()
// 全局过滤器
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

Vue.use(ElementUI)

Vue.use(Viser);
Vue.use(Antd);
Vue.use(Viewer);
Vue.component('v-chart', vCharts);

Viewer.setDefaults({
    Options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: "data-source"
    }
});

// 全局混入监听页面刷新，路由配置中needRefresh为true则添加监听
Vue.mixin({
    created: function() {
        if (this.$route && this.$route.meta && this.$route.meta.needRefresh) {
            this.$watch("$store.state.router.toRefreshPage", function(
                newValue,
                oldValue
            ) {
                if (newValue.comName === this.$options.name) {
                    this.fetchList && this.fetchList();
                }
            });
        }
    }
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js